<template>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="controls/as-widget-container"></require>

  <div class="as-widget-list">
    <div class="as-widget-list__item li-${item.kind || defaultKind}" reorderable-repeat.for="item of items" reorderable-dnd-handler-selector.bind="handlerSelector">
      <div class="as-widget-list__item-main">
        <as-widget-container kind.bind="item.kind || defaultKind" model.bind="item" disabled.bind="disabled" index.bind="$index"></as-widget-container>
      </div>
      <div class="as-widget-list__item-controls" show.bind="!hideListGutter">
        <div class="fa-lg fa-fw"></div>
        <div class="btn-group-vertical btn-group-sm">
          <button type="button" class="btn btn-icon text-danger" click.delegate="removeItem(item)" show.bind="removable && !disabled && (!hideLastRemove || items.length > 1)">
            <i class="fas fa-times"></i>
          </button>
          <button type="button" class="btn btn-icon d-none ${reorderable && !disabled ? 'd-sm-block' : ''} __handler ${handlerClass}" disabled.bind="items.length <= 1" data-placement="left" title="Drag to reorder" bs-tooltip>
            <i class="fas fa-grip-lines"></i>
          </button>
          <button type="button" class="btn btn-icon d-md-none" click.delegate="reorderItem(item, $index - 1)" disabled.bind="!($index > 0)" show.bind="reorderable && !disabled">
            <i class="fas fa-arrow-up"></i>
          </button>
          <button type="button" class="btn btn-icon d-md-none" click.delegate="reorderItem(item, $index + 1)" disabled.bind="!($index < items.length - 1)" show.bind="reorderable && !disabled">
            <i class="fas fa-arrow-down"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
